import { render, staticRenderFns } from "./CompanyPartnerConfirmationForm.vue?vue&type=template&id=726d39c7&"
import script from "./CompanyPartnerConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./CompanyPartnerConfirmationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports